import axios from "axios";

// In produzione frontend e API sono serviti dallo stesso dominio. In locale
// REACT_APP_BACKEND_URL punta invece al backend sulla porta 8001.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("fiscoai_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("fiscoai_token");
            localStorage.removeItem("fiscoai_user");
            if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);
